import * as React from 'react';

import {DataNoticePopover} from '../data-notice-popover/data-notice-popover';
import {
    ReviewEnrichmentDataModal,
    type EnrichmentResponseStatus,
} from '../review-enrichment-data-modal/review-enrichment-data-modal';

import {useGetContactEnrichment, useEnrichContact} from './graphql/hooks';
import {formatData, shouldShowData} from './helpers';

type Props = {
    contactId: string;
    contactName: string | null | undefined;
};

export function ContactEnrichmentWrapper(props: Props) {
    const [isShowingModal, setIsShowingModal] = React.useState<boolean>(false);
    const [isPopoverDismissed, setIsPopoverDismissed] = React.useState<boolean>(false);
    const [actionStatus, setActionStatus] = React.useState<
        EnrichmentResponseStatus | null | undefined
    >(undefined);

    const {contactEnrichment} = useGetContactEnrichment({id: props.contactId});
    const {enrichContact, isLoading, error} = useEnrichContact();

    const {mainFields, additionalFields} = formatData(contactEnrichment);

    const onContactEnrichmentRespond = (
        isBaseFieldsAccepted: boolean,
        isSocialProfilesChecked: boolean,
        isRelatedCompanyChecked: boolean
    ) => {
        const anyFieldsAccepted =
            isBaseFieldsAccepted || isRelatedCompanyChecked || isSocialProfilesChecked;
        setActionStatus(anyFieldsAccepted ? 'ACCEPTED' : 'DECLINED');
        enrichContact({
            contactId: props.contactId,
            baseFieldsResponse: isBaseFieldsAccepted ? 'ACCEPTED' : 'DECLINED',
            companyFieldsResponse: isRelatedCompanyChecked ? 'ACCEPTED' : 'DECLINED',
            socialFieldsResponse: isSocialProfilesChecked ? 'ACCEPTED' : 'DECLINED',
        })
            .then(() => {
                setIsPopoverDismissed(true);
                setIsShowingModal(false);
                if (anyFieldsAccepted) {
                    window.location.reload();
                }
            })
            .catch(() => {
                setActionStatus('ERROR');
            });
    };

    if (!contactEnrichment || !shouldShowData(mainFields, additionalFields)) {
        return null;
    }

    return (
        <>
            {!isPopoverDismissed && (
                <DataNoticePopover
                    entityName={
                        props.contactName ? <strong>{props.contactName}</strong> : 'this contact'
                    }
                    onClickReview={() => {
                        setIsShowingModal(true);
                    }}
                    onClickDismiss={() => {
                        setIsPopoverDismissed(true);
                    }}
                />
            )}
            {isShowingModal && (
                <ReviewEnrichmentDataModal
                    entityName={props.contactName}
                    onClose={() => setIsShowingModal(false)}
                    data={mainFields}
                    additionalFields={{...additionalFields}}
                    onSave={(isSocialProfilesChecked, isRelatedCompanyChecked) => {
                        if (isSocialProfilesChecked != null && isRelatedCompanyChecked != null) {
                            onContactEnrichmentRespond(
                                true,
                                isSocialProfilesChecked,
                                isRelatedCompanyChecked
                            );
                        }
                    }}
                    onDecline={() => {
                        onContactEnrichmentRespond(false, false, false);
                    }}
                    error={error}
                    loading={isLoading}
                    actionStatus={actionStatus}
                    setActionStatus={setActionStatus}
                />
            )}
        </>
    );
}
